export default class EncryptionUtil {
    static encryption(password) {
        return password
    }



}